package games.polyclub.website.frontend.store.sitemap

import games.polyclub.frontend.lib.react.simplified.SFC
import games.polyclub.service.payment.api.id.OrderId
import games.polyclub.tool.strings.id.UniqueId.Companion.parseUniqueId
import games.polyclub.website.frontend.store.pages.*
import games.polyclub.website.frontend.store.pages.aof7.AllOfFabric7Page
import games.polyclub.website.frontend.store.pages.skyfactory.SkyFactoryPage
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import react.ComponentType
import react.Props
import react.router.useNavigate
import react.router.useParams
import react.useEffectOnce
import web.cssom.px

@Serializable
@SerialName("public")
enum class PublicSitemap(
    override val pathPart: String,
    override val icon: Icon?,
    override val title: String,
    override val parent: PublicSitemap? = null,
    override val component: ComponentType<*>? = null,
    override vararg val tags: String,
    override val shortTitle: String = title,
    override val hidden: Boolean = false,
    override val isCustomLayout: Boolean = false,
): ISitemap {
    HOME("", Icon("fa-tachometer-alt"), "Início", hidden = true, component = SFC<Props> {
        val navigate = useNavigate()
        useEffectOnce {
            navigate(AOF7.path)
        }
    }),
    REGISTER("register", null, "Registrar Conta", hidden = true, component = RegisterPage, isCustomLayout = true),
    TERMS("terms", null, "Termos de Uso", hidden = true, component = TermsPage),
    PRIVACY_TERMS("privacy-terms", null, "Termos de Privacidade", hidden = true, component = PrivacyTermsPage),
    GIFT_TERMS("gift-terms", null, "Termos e Condições para Compras de Presentes", hidden = true, component = GiftTermsPage),
    GIVEAWAY_PURCHASE_TERMS("giveaway-terms", null, "Termos e Condições para Compras de Produtos para Sorteio", hidden = true, component = GiveawayPurchaseTerms),
    GIVEAWAY_CLAIM_TERMS("claim-giveaway-terms", null, "...", hidden = true),
    SKYFACTORY("skyfactory", Icon.src("/img/skyfactory/icon.png", width = 32.px, height = 32.px), "GameMods: SkyFactory", component = SkyFactoryPage),
    AOF7("aof7", Icon.src("/img/aof7/icon32x32.png"), "GameMods: All of Fabric", component = AllOfFabric7Page),
    LEGACY_PAY_ROOT("pay", null, "Pagamentos (legado)", hidden = true),
    BUY("buy", null, "Comprar (legado)", hidden = true, component = SFC<Props> { _ ->
        val navigate = useNavigate()
        useEffectOnce {
            navigate(AOF7.path)
        }
        MissingPage()
    }),
    LEGACY_PAY(":orderId", null, "Pagamento (legado)", parent = LEGACY_PAY_ROOT, hidden = true, component = SFC<Props> { _ ->
        val params = useParams()
        val orderId = try {
            OrderId(params["orderId"]!!.parseUniqueId())
        } catch (e: Exception) {
            e.printStackTrace()
            MissingPage()
            return@SFC
        }

        val navigate = useNavigate()
        useEffectOnce {
            navigate("${LoggedSitemap.PAY_ROOT.path}/$orderId")
        }
        MissingPage()
    }),
    ;

    override val rootPath get() = ""
    override val pathParts = super.pathParts
    override val path = super.path
    override val children by lazy {
        entries.filter { it.parent == this }
    }

    companion object {
        val root = entries.filter { it.parent == null }
    }
}
